import { combineReducers } from "@reduxjs/toolkit";

import { mainReducer } from "./main/mainSlice";
import { supplierReducer } from "./main/supplierSlice";
const rootReducer = combineReducers({
  main: mainReducer,
  supplier: supplierReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
